<template>
  <section class="sec sec-07 mt-5 mb-5 sec-padding">
    <div class="container-fluid">
      <div class="row">
        <div class="sec-title has-u-line">
          <h1 class="wow fadeInUp has-u-line" data-wow-duration="1s" data-wow-delay=".1s" v-html="title"></h1>
          <p class="text-center fadeInUp" data-wow-duration="1s" data-wow-delay=".4s" v-html="titleSub"> </p>
        </div>
      </div>
      <div class="row justify-content-center">
          <div class="col-lg-6 col-sm-8">
                <div class="box-con">
              <div class="neo-form-box">
                <div class="row">
                <div class="col-lg-8 ">
                  <div class="input-box">
                    <input type="text" class="neo-input" placeholder="Enter Your Email Address" id="userEmail2" v-model="userEmail">
                    <p class="info" v-html="formMessage"></p>
                  </div>
                </div>
                <div class="col-lg-4 ">
                  <div class="input-box">
                    <button class="neo-input" type="submit"  @click="submitUserEmail()">Get Early Access</button>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </section>
</template>
<style >
.sec-07{
    padding: 30px 0px 60px 0px;
    background: #222225;
}
</style>
<script>
import helpers from '@/plugins/helpers' 
import axios from 'axios'
export default {
  props: {
      title: { type: String, default: ""},
      titleSub:{type:String,default:''}
    },
  data() {
    return {
      userEmail:'',
      formMessage:'',
      usedForm:false
    };
  },
  mounted() {
    //this.cursorAnim();
     
  },
  methods: {
    submitUserEmail:function(){
      if(this.usedForm) return false;
      document.querySelector('#userEmail2').classList.remove('has-error')
      if(!helpers.validateEmail(this.userEmail)){
          document.querySelector('#userEmail2').classList.add('has-error')
        return false
      }else{
          var data = JSON.stringify({ email: this.userEmail,"data": { "message":'Get Early Access!'} });
          var config = {
            method: 'post', url: 'https://api.mailmodo.com/api/v1/at/c/rWpob6EHX2/d9ac7c96-4136-5708-ba67-14c9e26c2c0a',
            headers: { 'Content-Type': 'application/json'},
            data : data
            };
          let self=this;
          axios(config).then(function (response) {
              self.userEmail=""
              self.usedForm=true
              self.formMessage = 'Submitted Successfully'
              console.log(JSON.stringify(response.data))
          }).catch(function (error) {
              console.log(error);
          });
      }
    }
  },
};
</script>